export class MockNavigator {
  appCodeName = 'MockNavigator';
  appName = 'MockNavigator';
  appVersion = 'MockNavigator';
  platform = 'MockNavigator';
  userAgent = 'MockNavigator';
}
